import { Box, IconButton, Tooltip } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { BsFillPersonFill } from 'react-icons/bs';
import {
  HiOutlineDocumentText,
  HiOutlineCurrencyDollar,
  HiReceiptTax,
  HiOutlineEye,
} from 'react-icons/hi';
import { useNavigate } from 'react-router-dom';
import { getAllClosuresByInvoiceId } from 'wisestep-api';
import { WsColors, WsTypography } from 'wisestep-base';

import { getCurrencySymbol } from '../../../utils';
import { getFeeArrangementFees } from '../../clientDetails/components/contractArrangementsTab';
import { ClosureDetailsDTO } from '../../closures/types';

import InvoiceDetailsCard, { InvoiceDetailsCardAttribute, properties } from './InvoiceDetailsCard';

const PlacementDetails = ({ invoiceId }: { invoiceId: string }) => {
  const navigate = useNavigate();
  const [closures, setClosures] = useState<ClosureDetailsDTO[]>();
  useEffect(() => {
    (async () => {
      const response = await getAllClosuresByInvoiceId(invoiceId);
      setClosures(response.data.map((c) => new ClosureDetailsDTO(c)));
    })();
  }, [invoiceId]);
  if (!closures) return null;
  return (
    <>
      {closures.map((closure, index) => (
        <Box key={index} pt={2}>
          <InvoiceDetailsCard
            icon={<BsFillPersonFill color={WsColors.TheBlues500} size={22} />}
            right={
              <Tooltip title="View Placements" placement="top">
                <IconButton sx={{ m: -1 }} onClick={() => navigate('/placements/' + closure.id)}>
                  <HiOutlineEye color={WsColors.GreyBlack} />
                </IconButton>
              </Tooltip>
            }
            title={closure.candidate.name ?? ''}
          >
            <InvoiceDetailsCardAttribute columns={4} tooltipTitle="Salary">
              <HiOutlineCurrencyDollar />
              <WsTypography {...properties}>
                {closure.sellRateCurrency
                  ? getCurrencySymbol(closure?.sellRateCurrency?.symbol)
                  : ''}
                {closure.sellRateAmount}
              </WsTypography>
            </InvoiceDetailsCardAttribute>
            <InvoiceDetailsCardAttribute columns={5} tooltipTitle="Fee Arrangement">
              <HiReceiptTax />
              <WsTypography {...properties}>
                {getFeeArrangementFees(closure.feeArrangement)}
              </WsTypography>
            </InvoiceDetailsCardAttribute>
            <InvoiceDetailsCardAttribute columns={3} tooltipTitle="Invoice Amount">
              <HiOutlineDocumentText />
              <WsTypography {...properties}>
                {closure.sellRateCurrency ? getCurrencySymbol(closure.sellRateCurrency.symbol) : ''}
                {closure.commissionValue}
              </WsTypography>
            </InvoiceDetailsCardAttribute>
          </InvoiceDetailsCard>
        </Box>
      ))}
    </>
  );
};

export default PlacementDetails;
